import { render, staticRenderFns } from "./ChooseDeliveryTime.vue?vue&type=template&id=37fe5a99&scoped=true&"
import script from "./ChooseDeliveryTime.vue?vue&type=script&lang=js&"
export * from "./ChooseDeliveryTime.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDeliveryTime.vue?vue&type=style&index=0&id=37fe5a99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe5a99",
  null
  
)

export default component.exports